import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getCurrency,
  getParticularPage,
  getNext,
  getPrevious,
  createCurrency,
  updateCurrency,
  handleSearch,
  getCurrencyById,
} from "./thunk";

const initialState = {
  countries: [],
  edit: false,
  currency: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingCurrency: false,
  loadingNext: false,
  showCreateModal: false,
};

export const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllCurrency: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingCurrency = false;
      state.currency = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createCurrency.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createCurrency.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createCurrency.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(getCurrencyById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCurrencyById.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = true;
      state.currency = action.payload.data;
    });
    builder.addCase(getCurrencyById.rejected, (state) => {
      state.loading = false;
      state.edit = false;
      state.currency = null;
    });
    builder.addCase(updateCurrency.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateCurrency.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateCurrency.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getCurrency.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingCurrency = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCurrency.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingCurrency = false;
        state.countries = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getCurrency.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingCurrency = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllCurrency } = currencySlice.actions;

export default currencySlice.reducer;
